import {
  AddArchiveIcon,
  CartIcon,
  ArchiveIcon,
  BagIcon,
  CarbonNeutralIcon,
  CheckEmptyIcon,
  CheckFillIcon,
  CircleCheckIcon,
  CircleNextIcon,
  CirclePlusIcon,
  CloseIcon,
  ColorWheelIcon,
  CopyIcon,
  DownIcon,
  EditIcon,
  EditDeskIcon,
  ForwardIcon,
  GridDefaultIcon,
  GridListIcon,
  GridFlowIcon,
  GridCutsheetIcon,
  HeartIcon,
  HistoryIcon,
  InfoIcon,
  LinkIcon,
  Logoicon,
  MoveAroundIcon,
  MoveToIcon,
  PaperclipIcon,
  PdfIcon,
  PeopleIcon,
  PlusIcon,
  QrCodeIcon,
  ScaleLargeIcon,
  ScaleMediumIcon,
  ScaleSmallIcon,
  ShapesIcon,
  TagIcon,
  TickIcon,
  TrashIcon,
  TwinkleIcon,
  UpIcon,
  UploadIcon,
  Lighting,
  Hardware,
  Minus,
  Centered,
  List,
  ListNarrow,
  LineArrow,
  EmptyBag,
  PlusSlim,
  Brush,
  Play,
  FullScreen,
  ExtendIcon,
  Envelope,
  HeartWithBoldedBorders,
  ImageIcon,
  AlertInfoIcon,
  ImageRounded,
  EraserRounded,
  TemplatesRounded,
  SearchImageIcon,
  GridTableIcon,
  Add,
  AddPhoto,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Back,
  Box,
  Carbon,
  Cart,
  Catalog,
  Check,
  Clock,
  Cog,
  Cross,
  Delete,
  Download,
  Filters,
  Home,
  Inbox,
  Menu,
  More,
  MuteOff,
  MuteOn,
  NewMessage,
  Newtab,
  Number,
  Orders,
  Pin,
  Project,
  QR,
  Refer,
  Return,
  Search,
  Share,
  User,
  UserV2,
  Users,
  VideoOff,
  VideoOn,
  Wishlist,
  AlignCenter,
  AlignLeft,
  AlignRight,
  Arrow,
  Background,
  Board,
  Bold,
  Color,
  ColorPicker,
  Command,
  Constrain,
  Contacts,
  Counter,
  DoubleCheck,
  Erase,
  Hide,
  LessInfo,
  MoreInfo,
  Overnight,
  Rotation,
  Show,
  Sorting,
  SortingAtoZ,
  SortingZtoA,
  Stroke,
  Sustainability,
  Text,
  Underline,
  Video,
  Ellipse,
  Rectangle,
  Line,
  Italik,
  Letter,
  Architect,
  Professional,
  Representative,
  Student,
  CounterS,
  WishlistIncluded,
  ExitFullScreenIcon,
  FiltersThin,
  GridTransparent,
  SustainabilityLogo,
  ZoomLens,
  ShippedIcon,
  ShippingIcon,
  Phone,
  SpeechBubble,
  SpeechBubbleDots,
  Videocall,
  Calendar,
  ThumbUp,
  File,
  CartPlus,
  Price,
  FilePlus,
  LangEnglish,
  LangFrench,
  LangGerman,
  LangItalian,
  LangSpanish,
  SpinnerIcon,
  CameraIcon,
  OutlinedCircleCheck,
  PendingIcon,
  LinkV2,
  LeftArrowAltIcon,
  BookmarkIcon,
  Trending,
  ScrollPlayIcon,
  ScrollPauseIcon,
  MailIcon,
  DigitalCatalogIcon,
  Globe,
  NewMessages,
  SustainabilityFace,
  SustainabilityV2,
  SustainabilityCap,
} from 'icons';
import CircleIcon from 'icons/CircleIcon';
import * as subcategoryIcons from 'icons/subcategories';

export const Illustrations = {
  upload: UploadIcon,
  lighting: Lighting,
  hardware: Hardware,
  link: LinkIcon,
};

const Icons = {
  'sustainability-face': SustainabilityFace,
  'sustainability-v2': SustainabilityV2,
  'sustainability-cap': SustainabilityCap,
  'new-messages': NewMessages,
  globe: Globe,
  'link-v2': LinkV2,
  'image-rounded': ImageRounded,
  'eraser-rounded': EraserRounded,
  'templates-rounded': TemplatesRounded,
  'add-archive': AddArchiveIcon,
  'cart-material': CartIcon,
  archive: ArchiveIcon,
  'alert-info': AlertInfoIcon,
  bag: BagIcon,
  bookmark: BookmarkIcon,
  'carbon-neutral': CarbonNeutralIcon,
  'check-empty': CheckEmptyIcon,
  'check-filled': CheckFillIcon,
  'circle-check': CircleCheckIcon,
  'circle-next': CircleNextIcon,
  'circle-plus': CirclePlusIcon,
  close: CloseIcon,
  colorwheel: ColorWheelIcon,
  copy: CopyIcon,
  down: DownIcon,
  edit: EditIcon,
  'edit-desk': EditDeskIcon,
  forward: ForwardIcon,
  'grid-default': GridDefaultIcon,
  'grid-list': GridListIcon,
  'grid-flow': GridFlowIcon,
  'grid-cutsheet': GridCutsheetIcon,
  'grid-table': GridTableIcon,
  'grid-transparent': GridTransparent,
  heart: HeartIcon,
  history: HistoryIcon,
  info: InfoIcon,
  link: LinkIcon,
  logo: Logoicon,
  'move-around': MoveAroundIcon,
  'move-forward': MoveToIcon,
  paperclip: PaperclipIcon,
  pdf: PdfIcon,
  people: PeopleIcon,
  plus: PlusIcon,
  'qr-code': QrCodeIcon,
  'scale-large': ScaleLargeIcon,
  'scale-medium': ScaleMediumIcon,
  'scale-small': ScaleSmallIcon,
  shapes: ShapesIcon,
  tag: TagIcon,
  tick: TickIcon,
  trash: TrashIcon,
  twinkle: TwinkleIcon,
  up: UpIcon,
  circle: CircleIcon,
  minus: Minus,
  centered: Centered,
  list: List,
  'list-narrow': ListNarrow,
  'line-arrow': LineArrow,
  'empty-bag': EmptyBag,
  brush: Brush,
  extend: ExtendIcon,
  play: Play,
  'plus-slim': PlusSlim,
  'full-screen': FullScreen,
  envelope: Envelope,
  'heart-with-bolded-borders': HeartWithBoldedBorders,
  image: ImageIcon,
  searchImage: SearchImageIcon,
  upload: UploadIcon,
  add: Add,
  'add-photo': AddPhoto,
  'arrow-down': ArrowDown,
  'arrow-left': ArrowLeft,
  'arrow-left-alt': LeftArrowAltIcon,
  'arrow-right': ArrowRight,
  'arrow-up': ArrowUp,
  back: Back,
  box: Box,
  carbon: Carbon,
  cart: Cart,
  catalog: Catalog,
  check: Check,
  clock: Clock,
  cog: Cog,
  cross: Cross,
  delete: Delete,
  download: Download,
  filters: Filters,
  'sorting-thin': FiltersThin,
  fullscreen: FullScreen,
  home: Home,
  inbox: Inbox,
  menu: Menu,
  more: More,
  'mute-off': MuteOff,
  'mute-on': MuteOn,
  'new-message': NewMessage,
  'new-tab': Newtab,
  number: Number,
  orders: Orders,
  pin: Pin,
  project: Project,
  qr: QR,
  refer: Refer,
  return: Return,
  search: Search,
  share: Share,
  user: User,
  'user-v2': UserV2,
  users: Users,
  'video-off': VideoOff,
  'video-on': VideoOn,
  wishlist: Wishlist,
  acoustical: subcategoryIcons.Acoustical,
  appliances: subcategoryIcons.Appliances,
  'bedroom-sleepers': subcategoryIcons.BedroomSleepers,
  bath: subcategoryIcons.Bath,
  decking: subcategoryIcons.Decking,
  'decor-treatments': subcategoryIcons.DecorTreatments,
  'desks-tables': subcategoryIcons.DesksTables,
  film: subcategoryIcons.Film,
  flooring: subcategoryIcons.Flooring,
  facade: subcategoryIcons.Facade,
  surfaces: subcategoryIcons.Surfaces,
  storage: subcategoryIcons.Storage,
  'stair-elevator': subcategoryIcons.StairElevator,
  tile: subcategoryIcons.Tile,
  textile: subcategoryIcons.Textile,
  outdoor: subcategoryIcons.Outdoor,
  'window-treatments': subcategoryIcons.WindowTreatments,
  paints: subcategoryIcons.Paints,
  metal: subcategoryIcons.Metal,
  leather: subcategoryIcons.Lether,
  seating: subcategoryIcons.Seating,
  'panels-systems': subcategoryIcons.PanelsSystems,
  'masonry-stone': subcategoryIcons.MasonryStone,
  lighting: subcategoryIcons.Lighting,
  kitchen: subcategoryIcons.Kitchen,
  'space-dividers': subcategoryIcons.SpaceDividers,
  rugs: subcategoryIcons.Rugs,
  resin: subcategoryIcons.Resin,
  glass: subcategoryIcons.Glass,
  wallcovering: subcategoryIcons.Wallcovering,
  'millwork-moulding': subcategoryIcons.MillworkMoulding,
  hardware: subcategoryIcons.Hardware,
  roofing: subcategoryIcons.Roofing,
  'align-center': AlignCenter,
  'align-left': AlignLeft,
  'align-right': AlignRight,
  arrow: Arrow,
  background: Background,
  board: Board,
  bold: Bold,
  color: Color,
  'color-picker': ColorPicker,
  command: Command,
  constrain: Constrain,
  contacts: Contacts,
  counter: Counter,
  'double-check': DoubleCheck,
  erase: Erase,
  hide: Hide,
  'less-info': LessInfo,
  'more-info': MoreInfo,
  overnight: Overnight,
  rotation: Rotation,
  show: Show,
  sorting: Sorting,
  'sorting-a-to-z': SortingAtoZ,
  'sorting-z-to-a': SortingZtoA,
  stroke: Stroke,
  sustainability: Sustainability,
  text: Text,
  underline: Underline,
  video: Video,
  ellipse: Ellipse,
  rectangle: Rectangle,
  line: Line,
  italik: Italik,
  letter: Letter,
  architect: Architect,
  professional: Professional,
  representative: Representative,
  student: Student,
  'counter-s': CounterS,
  'wishlist-included': WishlistIncluded,
  'exit-full-screen': ExitFullScreenIcon,
  'sustainability-logo': SustainabilityLogo,
  'zoom-lens': ZoomLens,
  shipping: ShippingIcon,
  shipped: ShippedIcon,
  phone: Phone,
  'speech-bubble': SpeechBubble,
  'speech-bubble-dots': SpeechBubbleDots,
  'video-call': Videocall,
  calendar: Calendar,
  'thumb-up': ThumbUp,
  file: File,
  'cart-plus': CartPlus,
  price: Price,
  'file-plus': FilePlus,
  'flag-english': LangEnglish,
  'flag-spanish': LangSpanish,
  'flag-german': LangGerman,
  'flag-italian': LangItalian,
  'flag-french': LangFrench,
  spinner: SpinnerIcon,
  camera: CameraIcon,
  'outlined-circle-check': OutlinedCircleCheck,
  pending: PendingIcon,
  trending: Trending,
  scrollPlay: ScrollPlayIcon,
  scrollPause: ScrollPauseIcon,
  'digital-catalog': DigitalCatalogIcon,
  mail: MailIcon,
};

export type IconType = keyof typeof Icons;
export type IllustrationType = keyof typeof Illustrations;

export default Icons;
